(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('TacViewController', TacViewController);

		TacViewController.$inject = ['$scope', 'TACViewForEntitiesService'];

    function TacViewController ($scope,TACViewForEntitiesService ) {
        var vm = this;

        clearcorpTACFile();

   function clearcorpTACFile(){
	   TACViewForEntitiesService.getClearCorpTAC(function(result){
                vm.clearcorpTAC = result.data;
				previewTACForArray(vm.clearcorpTAC, 'ClearCorp_TAC.pdf');
				
	   })
	
    }

//    function clearcorpTACFile(){
//     // Your service call
//     TACViewForEntitiesService.getClearCorpTAC({}, function (response) {
//         vm.arrayBuffer = response.data;

//         vm.loadingTask = pdfjsLib.getDocument({ data:  vm.arrayBuffer });
//         vm.loadingTask.promise.then(function (pdf) {
//             vm.totalPages = pdf.numPages;
//             vm.pages = [];

//             for (let pageNum = 1; pageNum <= pdf.numPages; pageNum++) {
//                 pdf.getPage(pageNum).then(function (page) {
//                     var scale = 1.5;
//                     var viewport = page.getViewport({ scale: scale });

//                     var canvas = document.createElement('canvas');
//                     canvas.width = viewport.width;
//                     canvas.height = viewport.height;
//                     var context = canvas.getContext('2d');

//                     page.render({
//                         canvasContext: context,
//                         viewport: viewport
//                     }).promise.then(function () {
//                         // Store base64 image of the page
//                         var imgData = canvas.toDataURL();
//                         vm.pages[pageNum - 1] = imgData;

//                         // Trigger digest if needed
//                         if (!vm.$$phase) {
//                             $scope.$apply();
//                         }
//                     });
//                 });
//             }
//         });
//     });
// };



//  function previewTACForArray(arrayBuffer, pdfFileName) {
// var file = new Blob([arrayBuffer], {type: 'application/pdf'});
//       		var filename = pdfFileName;
//             var fileURL = URL.createObjectURL(file);
//             if(window.navigator.msSaveOrOpenBlob) {
//                 window.navigator.msSaveOrOpenBlob(file, filename);
//             }
//             else {
            	
//                window.open(fileURL, filename, "fullscreen=yes");   
            	
// }
//  }

function previewTACForArray(arrayBuffer, pdfFileName) {
    var file = new Blob([arrayBuffer], { type: 'application/pdf' });
    var fileURL = URL.createObjectURL(file);

    // instead of opening new window, show inside current page
    document.getElementById("pdfContainer").innerHTML =
        '<embed src="' + fileURL + '" type="application/pdf" width="100%" height="100%">';
}

 }
})();